import type { ComponentType, PropsWithChildren } from 'react';
import React, { Fragment } from 'react';

import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { ExternalSharePageLoader } from '@confluence/external-share/entry-points/ExternalSharePage.ts';
import { expVal } from '@confluence/feature-experiments';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { getUniquePageLoadId } from '@confluence/unique-page-load-id/entry-points/UniquePageLoadId.ts';

export function getShareableLinkRoute({
	ContextProvider = Fragment,
	NotFound = Fragment,
}: GetShareableLinkRouteArgs = {}) {
	function ShareableLinkRoute({ params: { shareToken }, hash }: RouteMatch) {
		if (!expVal('shareable_links_m0', 'isEnabled', false)) {
			return <NotFound />;
		}

		return (
			<ContextProvider>
				<ExternalSharePageLoader shareToken={shareToken} queryHash={hash} />
			</ContextProvider>
		);
	}

	ShareableLinkRoute.NAVIGATION_PARAMS = ({ name }: RouteMatch) => ({
		Screen: {
			screenEvent: {
				name: 'viewPageScreen',
				attributes: {
					isPublicView: true,
					isShareableLinkView: true,
					pageLoadInfo: getUniquePageLoadId(),
				},
			},
			pageState: {
				routeName: name,
			},
		},
		MainLayout: {
			navView: PRODUCT_HOME_ID,
		},
	});

	return ShareableLinkRoute;
}

type GetShareableLinkRouteArgs = {
	ContextProvider?: ComponentType<PropsWithChildren<{}>>;
	NotFound?: ComponentType;
};

export const ShareableLinkRouteForSSR = getShareableLinkRoute();
